import { AnyObject, handleApiError } from "~/api"
import { post, patch } from "./utils/requests"

const adminSignupConfirmation = async (password: string, passwordConfirmation: string, token: string) => {
  const url: string = window.origin + `/admin/signup/${token}`

  const body: object = {
    password: password,
    password_confirmation: passwordConfirmation,
  }

  return post(url, { admin_user: body })
    .then((data: AnyObject) => {
      if (data.user) {
        return data.user
      } else {
        return Promise.reject(data)
      }
    })
    .catch(handleApiError)
}

const updateAdminPassword = async (
  _authenticity_token: string,
  password: string,
  passwordConfirmation: string,
  token: string,
) => {
  const url = "/admin/password"
  const body = {
    admin_user: {
      reset_password_token: token,
      password,
      password_confirmation: passwordConfirmation,
    },
  }

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "",
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const errorData = await response.json()
    throw new Error(errorData.errors?.join(", ") || errorData.message || "Password update failed")
  }

  return await response.json()
}

const Auth = {
  adminSignupConfirmation,
  updateAdminPassword,
}

export default Auth
